var React = require('react');

function DiceThree (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 32H64A64 64 0 0 0 0 96v320a64 64 0 0 0 64 64h320a64 64 0 0 0 64-64V96a64 64 0 0 0-64-64zM128 192a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 320a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-96-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-96-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

DiceThree.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = DiceThree;

DiceThree.default = DiceThree;
